/* Task 18: acordeoes da area de detalhe do produto. O servidor renderiza `<details open>`;
   abaixo de 750px o acordeao fecha (so tira `open`, o conteudo ja esta no DOM), acima disso
   abre e o toggle do <summary> e travado -- desktop fica como era antes da task. */
if (!customElements.get('details-accordion')) {
  customElements.define(
    'details-accordion',
    class DetailsAccordion extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.details && this.details.querySelector('summary');
        if (!this.summary) return;

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onSummaryClick = (event) => {
          if (!this.mobileQuery.matches) event.preventDefault();
        };
        this.onQueryChange = () => this.sync();

        this.summary.addEventListener('click', this.onSummaryClick);
        this.mobileQuery.addEventListener('change', this.onQueryChange);
        this.sync();
      }

      disconnectedCallback() {
        if (!this.summary) return;
        this.summary.removeEventListener('click', this.onSummaryClick);
        this.mobileQuery.removeEventListener('change', this.onQueryChange);
      }

      sync() {
        const mobile = this.mobileQuery.matches;
        this.details.open = !mobile;
        if (mobile) this.summary.removeAttribute('tabindex');
        else this.summary.setAttribute('tabindex', '-1');
      }
    }
  );
}
